module.exports = __webpack_public_path__ + "b3cf0448172c5bc7a15dbba088e7ef7c.MP3";